var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main--container"},[_c('div',{staticClass:"collections--container"},[_c('TitleContainer',{attrs:{"items":_vm.mainTitle,"text":_vm.mainP,"textAlign":'text-left'}}),_c('CollectionList',{attrs:{"languages":[]}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }